import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import SelectInput from 'components/forms/SelectInput';
import Text from 'components/Text';
import TooltipIcon from 'components/TooltipIcon';

import { cxHelpers } from 'util/className';
const { cxEl } = cxHelpers('OnboardingPacketRow');
import { toI18n } from 'util/i18n';

import { JOB_TAX_CLASSIFICATION_OPTIONS } from '../../../constants';

const ClassificationSelectInput = ({
  handleJobTaxClassificationChange,
  jobTaxClassification,
  errorBorder,
  canEditTaxClassification,
}) => (
  <Box pb24>
    <Box pb8>
      <Text fs14 fw600 i18n="add_team.individual_drawer.classification" />*
      <TooltipIcon
        color="grayDark"
        size={10}
        content={toI18n('add_team.individual_drawer.classification_tooltip')}
      />
    </Box>
    <Box>
      <SelectInput
        errorBorder={errorBorder && isEmpty(jobTaxClassification)}
        placeholder={toI18n(
          'add_team.individual_drawer.classification_placeholder'
        )}
        options={JOB_TAX_CLASSIFICATION_OPTIONS}
        searchable={false}
        onChange={handleJobTaxClassificationChange}
        value={jobTaxClassification}
        className={cxEl('taxClassification')}
        disabled={!canEditTaxClassification}
      />
    </Box>
  </Box>
);

ClassificationSelectInput.propTypes = {
  handleJobTaxClassificationChange: PropTypes.func.isRequired,
  errorBorder: PropTypes.bool,
};

export default ClassificationSelectInput;
